/*
 *
 * Home
 *
 */

import "../styles.scss";

import { API, Endpoints } from "utils/api";
import { AppointmentCard, Icons, SimpleAppointmentCard } from "components";
import {
	setAcceptedChat,
	setAudioRoom,
	setAudioSettings,
	setBreadcrumb,
	setFinishedChat,
	setLoader,
	setPendingCalls,
	setPendingChats,
	setRoom,
	setUser,
	setVideoSettings
} from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import React from "react";
import Strings from "utils/strings";
import UserPlaceholder from "assets/images/placeholders/user2x.jpg";
import { connect } from "react-redux";
import moment from "moment";
import { notification } from "antd";
import { push } from "connected-react-router";

export class Home extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			appointments: [],
			pendingChats: [],
			pendingCalls: [],
			pendingReport: [],
			callsNotAnswered: [],
			dailyAppointments: [],
			selectedDate: moment.utc().add(1, "day"),
			selectedMonth: moment.utc().format("MM YYYY"),
			showDrawer: false,
			selection: [],
			slots: [],
			finalSlots: []
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;
		dispatch(setBreadcrumb(null));

		this.getHome();
	}

	componentDidUpdate(prevState: any) {
		if (this.props.language === "pt") {
			moment.updateLocale("pt", {
				week: { dow: 1 }
			});
		} else if (this.props.language === "en") {
			moment.updateLocale("en-gb", {
				week: { dow: 1 }
			});
		} else {
			moment.updateLocale("es", {
				week: { dow: 1 }
			});
		}

		if (prevState.pendingCalls !== this.props.pendingCalls) {
			this.getHome();
			this.props.dispatch(setPendingCalls(null));
		}

		if (this.props.pendingChats) {
			this.getHome();
			this.props.dispatch(setPendingChats(false));
		}

		if (this.props.acceptedChat?.accepted) {
			this.getHome();
			this.props.dispatch(setAcceptedChat({ accepted: false, current: false, record: null }));
		}

		if (this.props.finishedChat?.finished) {
			if (this.state.pendingChats?.length > 0) {
				this.getHome();
			}

			this.props.dispatch(setFinishedChat({ finished: false, record: null }));
		}
	}

	async getHome() {
		const { selectedDate } = this.state;
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriHome(moment(selectedDate).format("YYYY-MM-DD"))
			});

			if (response.ok) {
				const {
					nextConsultations: appointments,
					pendingChats,
					psychologist,
					dayConsultations: dailyAppointments,
					pendingCalls,
					pendingReport,
					callsNotAnswered = []
				} = response.data.results;

				dispatch(setUser(psychologist));
				this.setState({
					appointments,
					dailyAppointments,
					pendingChats,
					pendingCalls,
					pendingReport,
					callsNotAnswered
				});
			} else {
				notification.error({
					message: Strings.sidebar.home,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.home,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async getSlots(loader: boolean = false) {
		const { selectedMonth } = this.state;
		const { dispatch } = this.props;

		const body: any = {
			endDate: moment.utc(selectedMonth, "MM YYYY").endOf("month").format("YYYY-MM-DD")
		};

		if (moment.utc().month() === moment.utc(selectedMonth, "MM YYYY").month()) {
			body.startDate = moment.utc().format("YYYY-MM-DD");
		} else {
			body.startDate = moment.utc(selectedMonth, "MM YYYY").startOf("month").format("YYYY-MM-DD");
		}

		if (loader) {
			dispatch(setLoader(true));
		}

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriSlots(),
				data: body
			});

			if (response.ok) {
				const { slots = [] } = response.data.results;

				const selection: Array<any> = [
					{
						month: moment.utc(selectedMonth, "MM YYYY").month(),
						year: moment.utc(selectedMonth, "MM YYYY").year(),
						days: []
					}
				];

				for (const slot of slots) {
					const newSelection = selection[0].days;
					const day = moment.utc(slot.date).date();
					if (!newSelection.includes(day)) {
						newSelection.push(day);
					}
				}

				let selectedDate: any;
				let finalSlots: Array<any> = [];
				if (slots.length) {
					selectedDate = moment.utc(slots[0].date);
					finalSlots = slots[0].slots || [];
				}

				this.setState({ selection, slots, selectedDate, finalSlots });
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		if (loader) {
			dispatch(setLoader(false));
		}
	}

	async acceptChat(chat: any) {
		const { dispatch, user } = this.props;

		if (chat.psychologist === user._id) {
			dispatch(push("/chat", { chatId: chat.psychologist ? chat.socketId : `${chat.socketId}${user._id}` }));
			return;
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.patch({
				url: Endpoints.uriChats(`accept/${chat._id}`),
				data: {}
			});

			if (response.ok) {
				dispatch(push("/chat", { chatId: chat.psychologist ? chat.socketId : `${chat.socketId}${user._id}` }));
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async startChatMissingCall(call: any) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			let body = {
				user: call.user._id,
				call: call._id
			} as any;

			response = await API.patch({
				url: Endpoints.uriChats("start"),
				data: body
			});

			if (response.ok) {
				const { chat } = response.data.results;
				dispatch(push("/chat", { chatId: chat.socketId }));
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async rejectMissingCall(call: any) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.patch({
				url: Endpoints.uriAudioCalls(`reject/${call._id}`),
				data: {}
			});

			if (response.ok) {
				const { callsNotAnswered } = response.data.results;
				this.setState({
					callsNotAnswered
				});
			} else {
				notification.error({
					message: Strings.sidebar.chat,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.chat,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async submitAppointment() {
		const { selectedDate, selectedSlot } = this.state;
		const { dispatch, user } = this.props;

		if (!selectedDate || !selectedSlot) return;

		dispatch(setLoader(true));

		let response: any;
		try {
			const body = {
				date: moment.utc(selectedDate).format("YYYY-MM-DD"),
				time: selectedSlot,
				user: user._id
			};

			response = await API.post({
				url: Endpoints.uriAppointments(),
				data: body
			});

			if (response.ok) {
				this.setState({ showDrawer: false });

				await this.getHome();

				notification.success({
					message: Strings.appointments.header,
					description: Strings.appointments.created,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.appointments.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	disabledDate = (current: any) => {
		const { selection } = this.state;
		const available = selection.some(
			(entry: any) =>
				current.year() === entry.year && current.month() === entry.month && entry.days.includes(current.date())
		);

		return !available;
	};

	disabledRange = (current: any) => {
		return moment.utc().add(-1, "days").isAfter(current);
	};

	startVideoCall = async (id: any, user?: any) => {
		const { dispatch, room, audioRoom } = this.props;

		if (room || audioRoom) {
			return notification.warn({
				message: Strings.home.pendingCalls,
				description: Strings.home.cantAcceptCall,
				placement: "bottomRight",
				duration: 5
			});
		}

		const response = await API.get({
			url: Endpoints.uriVideoCalls(`consultation/${id}`)
		});

		if (response.ok) {
			const { twilioRoom, userToken } = response.data.results;

			this.setState(
				{
					activeRoom: twilioRoom.roomSid,
					roomName: twilioRoom.uniqueName,
					room: twilioRoom,
					roomState: "disconnected",
					roomNameErr: false,
					previewTracks: null,
					token: userToken,
					localMediaAvailable: true,
					hasJoinedRoom: true,
					openVideoCallModal: true
				},
				() => {
					const room = { ...twilioRoom, user };
					dispatch(setRoom(room));
					dispatch(setVideoSettings({ token: userToken, activeVideo: true, room, appointmentId: id }));
				}
			);
		} else {
			this.setState({ roomNameErr: true });

			return notification.error({
				message: Strings.serverErrors.title,
				description: Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	};

	async acceptCall(call: any) {
		const { dispatch, room, audioRoom } = this.props;

		if (room || audioRoom) {
			return notification.warn({
				message: Strings.home.pendingCalls,
				description: Strings.home.cantAcceptCall,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.patch({
				url: Endpoints.uriAudioCalls(`accept/${call?._id}`),
				data: {}
			});

			if (response.ok) {
				const { twilioRoom, userToken } = response.data.results;

				dispatch(setAudioRoom(twilioRoom));
				dispatch(setAudioSettings({ token: userToken, activeAudio: true, room: twilioRoom, user: call.user }));
			} else {
				notification.error({
					message: Strings.home.pendingCalls,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.home.pendingCalls,
				description: response?.data?.message || (err as string) || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const { mobile, dispatch } = this.props;
		const { appointments, pendingChats, pendingCalls, pendingReport, callsNotAnswered } = this.state;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.home} | Team24</title>
					<meta name="description" content="Description of Home" />
				</Helmet>
				<div className="AppointmentsContent">
					<div className="AppointmentsMainWrapper">
						<div className="CardsWrapper --psychologist">
							<div className="AppointmentsDivisions">
								<div className="AppointmentsDivision">
									<h2>{Strings.home.dailyAppointments}</h2>
									<div className="HomeCardsWrapper">
										{appointments.map((appointment: any) => (
											<SimpleAppointmentCard
												key={`appointment_${appointment._id}`}
												noHeader
												isPsychologist
												appointment={appointment}
												onClick={async () => {
													this.startVideoCall(appointment._id, appointment.user);
												}}
											/>
										))}
										{appointments?.length === 0 && <p>{Strings.home.noAppointments}</p>}
									</div>
								</div>
								<div className="AppointmentsDivision">
									<h2>{Strings.home.pendingCalls}</h2>
									<div className="HomeCardsWrapper">
										{pendingCalls.length > 0 &&
											pendingCalls.map((call: any, index: number) => (
												<div key={`call_${index}`} className="CallCardWrapper">
													<div
														onClick={() => dispatch(push(`/patients/${call?.user?._id}`))}
														className="CallUserNameDetails"
													>
														<img
															src={call?.user?.photo || UserPlaceholder}
															alt="call avatar"
														/>
														<p>{`${call?.user?.name} | ${call?.business?.name}${
															call?.user?.language?.nativeName
																? " | " + call?.user?.language?.nativeName
																: ""
														}`}</p>
													</div>
													<div className="CallButtonContainer">
														<button
															onClick={() => {
																this.acceptCall(call);
															}}
															className="CallIconWrapper"
														>
															<Icons.VoiceCall />
														</button>
													</div>
												</div>
											))}
										{pendingCalls.length === 0 && <p>{Strings.home.noCalls}</p>}
									</div>
									<h2 className="HomeSectionTitle">{Strings.home.pendingChats}</h2>
									<div className="HomeCardsWrapper">
										{pendingChats.length > 0 &&
											pendingChats.map((chat: any, index: number) => (
												<div key={`chat_${index}`} className="ChatCardWrapper">
													<div
														onClick={() => dispatch(push(`/patients/${chat?.user?._id}`))}
														className="ChatUserNameDetails"
													>
														<img
															src={chat?.user?.photo || UserPlaceholder}
															alt="chat avatar"
														/>
														<p>{`${chat?.user?.name} | ${chat?.business?.name}${
															chat?.user?.language?.nativeName
																? " | " + chat?.user?.language?.nativeName
																: ""
														}`}</p>
													</div>
													<div className="ChatButtonContainer">
														<button
															onClick={() => this.acceptChat(chat)}
															className="ChatIconWrapper"
														>
															<Icons.ChatFilled color />
														</button>
													</div>
												</div>
											))}
										{pendingChats.length === 0 && <p>{Strings.home.noChats}</p>}
									</div>
									<h2 className="HomeSectionTitle">{Strings.home.callsNotAnswered}</h2>
									<div className="HomeCardsWrapper">
										{callsNotAnswered.length > 0 &&
											callsNotAnswered.map((call: any, index: number) => (
												<div key={`call_${index}`} className="MissingCallCardWrapper">
													<button
														className="MissingCallCloseCall"
														onClick={(e: any) => {
															e.stopPropagation();
															this.rejectMissingCall(call);
														}}
													>
														<em className="moon-close" />
													</button>
													<div
														onClick={() => dispatch(push(`/patients/${call?.user?._id}`))}
														className="MissingCallUserNameDetails"
													>
														<img
															src={call?.user?.photo || UserPlaceholder}
															alt="chat avatar"
														/>
														<p>{`${call?.user?.name} | ${call?.business?.name}${
															call?.user?.language?.nativeName
																? " | " + call?.user?.language?.nativeName
																: ""
														}`}</p>
													</div>
													<div className="MissingCallButtonContainer">
														<button
															onClick={() => this.startChatMissingCall(call)}
															className="MissingCallIconWrapper"
														>
															<Icons.ChatFilled color="#3277A3" />
														</button>
													</div>
												</div>
											))}
										{callsNotAnswered.length === 0 && <p>{Strings.home.noCallsNotAnswered}</p>}
									</div>
								</div>
								<div className="AppointmentsDivision">
									<h2>{Strings.appointments.pendingReport}</h2>
									<div className="HomeCardsWrapper">
										{pendingReport.length > 0 &&
											pendingReport.map((appointment: any) => (
												<AppointmentCard
													key={`appointment_${appointment._id}`}
													noButton
													isPsychologist
													appointment={appointment}
													noPatients
													onReschedule={() =>
														this.setState({
															showDrawer: true,
															submitType: {
																type: "edit",
																_id: appointment._id
															}
														})
													}
												/>
											))}
										{pendingReport.length === 0 && <p>{Strings.home.noAppointmentsReport}</p>}
									</div>
								</div>
							</div>
						</div>
					</div>

					{mobile && <Footer />}
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	user: state.user,
	mobile: state.mobile,
	room: state.room,
	audioRoom: state.audioRoom,
	pendingCalls: state.pendingCalls,
	pendingChats: state.pendingChats,
	pendingReport: state.pendingReport,
	callsNotAnswered: state.callsNotAnswered,
	acceptedChat: state.acceptedChat,
	finishedChat: state.finishedChat
});

export default connect(mapStateToProps)(Home);
